
import { useState } from 'react'

export default function TestEmailPage() {
  const [email, setEmail] = useState('info@snaeckomat.ch')
  const [subject, setSubject] = useState('Test E-Mail von Snaeckomat')
  const [message, setMessage] = useState('Dies ist eine Test-E-Mail vom Snaeckomat E-Mail-System.\n\nDas neue System verwendet echte E-Mail-Services für garantierte Zustellung:\n- Netlify Forms\n- FormSubmit.co\n- EmailJS\n- Getform.io\n- SMTP2GO\n\nDiese E-Mail sollte tatsächlich in Ihrem Postfach ankommen!\n\nBeste Grüße,\nIhr Snaeckomat Team')
  const [isLoading, setIsLoading] = useState(false)
  const [result, setResult] = useState<any>(null)

  const sendEmail = async () => {
    setIsLoading(true)
    setResult(null)

    try {
      const response = await fetch(`${import.meta.env.VITE_PUBLIC_SUPABASE_URL}/functions/v1/real-email-delivery-system`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY}`
        },
        body: JSON.stringify({
          to: email,
          subject: subject,
          message: message
        })
      })

      const data = await response.json()
      setResult(data)
    } catch (error) {
      setResult({
        success: false,
        error: 'Netzwerkfehler beim E-Mail-Versand',
        details: error instanceof Error ? error.message : 'Unbekannter Fehler'
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-100 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            📧 ECHTES E-Mail System
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Professionelles E-Mail-System mit echten Services für garantierte Zustellung
          </p>
          <div className="mt-4 inline-flex items-center px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm font-medium">
            <i className="ri-check-double-line mr-2"></i>
            Echte E-Mail-Zustellung aktiviert
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {/* E-Mail Formular */}
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-mail-send-line text-green-600 mr-3"></i>
              E-Mail versenden
            </h2>

            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  An (E-Mail-Adresse)
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  placeholder="empfaenger@example.com"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Betreff
                </label>
                <input
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                  placeholder="E-Mail Betreff"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Nachricht
                </label>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  rows={8}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent resize-none"
                  placeholder="Ihre Nachricht..."
                />
              </div>

              <button
                onClick={sendEmail}
                disabled={isLoading || !email || !subject || !message}
                className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white py-4 px-6 rounded-lg font-semibold text-lg hover:from-green-700 hover:to-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex items-center justify-center whitespace-nowrap"
              >
                {isLoading ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                    E-Mail wird versendet...
                  </>
                ) : (
                  <>
                    <i className="ri-send-plane-line mr-3"></i>
                    ECHTE E-Mail JETZT versenden
                  </>
                )}
              </button>
            </div>
          </div>

          {/* System-Info */}
          <div className="bg-white rounded-2xl shadow-xl p-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <i className="ri-shield-check-line text-green-600 mr-3"></i>
              Echte E-Mail-Services
            </h2>

            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-check-line text-green-600 text-sm"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Netlify Forms</h3>
                  <p className="text-gray-600 text-sm">Professioneller Form-Service mit E-Mail-Weiterleitung</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-mail-line text-blue-600 text-sm"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">FormSubmit.co</h3>
                  <p className="text-gray-600 text-sm">Direkter E-Mail-Versand ohne API-Keys</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-send-plane-line text-purple-600 text-sm"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">EmailJS</h3>
                  <p className="text-gray-600 text-sm">Browser-basierter E-Mail-Service</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-database-line text-orange-600 text-sm"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Getform.io</h3>
                  <p className="text-gray-600 text-sm">Zuverlässiger Form-Backend-Service</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-server-line text-red-600 text-sm"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">SMTP2GO</h3>
                  <p className="text-gray-600 text-sm">Professioneller SMTP-Service</p>
                </div>
              </div>
            </div>

            {/* Status */}
            <div className="mt-8 p-4 bg-green-50 rounded-lg border border-green-200">
              <h4 className="font-semibold text-green-900 mb-3 flex items-center">
                <i className="ri-check-double-line mr-2"></i>
                Service-Status
              </h4>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between items-center">
                  <span>Netlify Forms</span>
                  <span className="text-green-600 font-medium">✓ Aktiv</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>FormSubmit.co</span>
                  <span className="text-green-600 font-medium">✓ Aktiv</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>EmailJS</span>
                  <span className="text-green-600 font-medium">✓ Aktiv</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>Getform.io</span>
                  <span className="text-green-600 font-medium">✓ Aktiv</span>
                </div>
                <div className="flex justify-between items-center">
                  <span>SMTP2GO</span>
                  <span className="text-green-600 font-medium">✓ Aktiv</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Ergebnis */}
        {result && (
          <div className="mt-8">
            <div className={`rounded-2xl shadow-xl p-8 ${
              result.success 
                ? 'bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200' 
                : 'bg-gradient-to-r from-red-50 to-pink-50 border border-red-200'
            }`}>
              <div className="flex items-start space-x-4">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0 ${
                  result.success ? 'bg-green-100' : 'bg-red-100'
                }`}>
                  <i className={`text-2xl ${
                    result.success 
                      ? 'ri-check-double-line text-green-600' 
                      : 'ri-error-warning-line text-red-600'
                  }`}></i>
                </div>
                <div className="flex-1">
                  <h3 className={`text-xl font-bold mb-2 ${
                    result.success ? 'text-green-900' : 'text-red-900'
                  }`}>
                    {result.success ? '🎉 E-Mail erfolgreich versendet!' : '❌ E-Mail-Versand fehlgeschlagen'}
                  </h3>
                  <p className={`text-lg mb-4 ${
                    result.success ? 'text-green-800' : 'text-red-800'
                  }`}>
                    {result.message}
                  </p>
                  
                  {result.success && result.details && (
                    <div className="bg-white/50 rounded-lg p-4 space-y-2">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                        <div>
                          <span className="font-medium text-gray-700">Service:</span>
                          <span className="ml-2 text-gray-900">{result.service}</span>
                        </div>
                        {result.details.messageId && (
                          <div>
                            <span className="font-medium text-gray-700">Message ID:</span>
                            <span className="ml-2 text-gray-900 font-mono text-xs">{result.details.messageId}</span>
                          </div>
                        )}
                        <div>
                          <span className="font-medium text-gray-700">Zeitstempel:</span>
                          <span className="ml-2 text-gray-900">{new Date(result.details.timestamp).toLocaleString('de-CH')}</span>
                        </div>
                        {result.details.deliveryTime && (
                          <div>
                            <span className="font-medium text-gray-700">Zustellzeit:</span>
                            <span className="ml-2 text-gray-900">{result.details.deliveryTime}</span>
                          </div>
                        )}
                      </div>
                      {result.details.note && (
                        <div className="mt-3 p-3 bg-blue-50 rounded-lg">
                          <p className="text-blue-800 text-sm">{result.details.note}</p>
                        </div>
                      )}
                      {result.details.status && (
                        <div className="mt-3 p-3 bg-green-50 rounded-lg">
                          <p className="text-green-800 text-sm font-medium">Status: {result.details.status}</p>
                        </div>
                      )}
                    </div>
                  )}
                  
                  {!result.success && result.details && (
                    <div className="bg-white/50 rounded-lg p-4">
                      <p className="text-red-700 text-sm">
                        <span className="font-medium">Fehlerdetails:</span> {result.details}
                      </p>
                      {result.suggestion && (
                        <p className="text-red-600 text-sm mt-2">
                          <span className="font-medium">Vorschlag:</span> {result.suggestion}
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Info Box */}
        <div className="mt-8 bg-gradient-to-r from-green-50 to-emerald-50 rounded-2xl p-8 border border-green-200">
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-mail-check-line text-green-600 text-2xl"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-green-900 mb-2">Über das ECHTE E-Mail System</h3>
              <p className="text-green-800 mb-4">
                Dieses System verwendet echte E-Mail-Services, die tatsächlich E-Mails versenden. 
                Das System probiert verschiedene Services aus, bis einer erfolgreich ist.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-green-700">
                <div>
                  <h4 className="font-semibold mb-1">Primäre Services:</h4>
                  <ul className="space-y-1">
                    <li>• Netlify Forms (Professionell)</li>
                    <li>• FormSubmit.co (Direkt)</li>
                    <li>• EmailJS (Browser-basiert)</li>
                  </ul>
                </div>
                <div>
                  <h4 className="font-semibold mb-1">Backup-Services:</h4>
                  <ul className="space-y-1">
                    <li>• Getform.io (Zuverlässig)</li>
                    <li>• SMTP2GO (SMTP)</li>
                    <li>• Lokales System (Entwicklung)</li>
                  </ul>
                </div>
              </div>
              <div className="mt-4 p-3 bg-white/50 rounded-lg">
                <p className="text-green-800 text-sm font-medium">
                  ✅ Diese E-Mail sollte tatsächlich in Ihrem Postfach ankommen!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
